import React, { useState } from 'react';
import '../../css/JuanIS/JuanISStudentLedger.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faPrint } from '@fortawesome/free-solid-svg-icons';

function JuanISStudentLedger() {
  const [paymentAmount, setPaymentAmount] = useState('');
  const [feedback, setFeedback] = useState('');
  const [selectedAssessment, setSelectedAssessment] = useState('');

  const handlePaymentSubmit = (e) => {
    e.preventDefault();
    // Handle payment submission logic here
  };

  const handleDownload = () => {
    // Handle PDF download logic
  };

  const handlePrint = () => {
    window.print();
  };

  const handleAddComment = () => {
    // Handle feedback submission logic
    setFeedback('');
  };

  return (
    <div className="juanis-student-ledger-container">
      <div className="juanis-student-ledger-card">
        <h1>Student Ledger</h1>
        
        <div className="juanis-student-ledger-student-info">
          <p><strong>Student ID:</strong> 2025-123456</p>
          <p><strong>Course/Program:</strong> Bachelor of Science in Information Technology with specialization in Mobile and Web Applications (BSIT-MWA)</p>
        </div>

        <div className="juanis-student-ledger-balance-section">
          <div className="juanis-student-ledger-balance-date">As of 04 Feb 2024</div>
          <div className="juanis-student-ledger-balance-amount">-200.00</div>
        </div>

        <div className="juanis-student-ledger-assessment-section">
          <select 
            className="juanis-student-ledger-assessment-select"
            value={selectedAssessment}
            onChange={(e) => setSelectedAssessment(e.target.value)}
          >
            <option value="">Assessment #22-01731</option>
            <option value="1">Previous Assessment</option>
          </select>
        </div>

        <div className="juanis-student-ledger-content">
          <table className="juanis-student-ledger-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Transaction</th>
                <th>Principal</th>
                <th>Description</th>
                <th>Debit</th>
                <th>Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>2023-09-01</td>
                <td>Assessment</td>
                <td>20,000.00</td>
                <td>Cash Payment</td>
                <td>19,800.00</td>
                <td>-200.00</td>
              </tr>
              <tr>
                <td>2023-09-14</td>
                <td>Refund</td>
                <td>200.00</td>
                <td>Fee refund</td>
                <td></td>
                <td>-200.00</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>Total</td>
                <td></td>
                <td>20,200.00</td>
                <td></td>
                <td>19,800.00</td>
                <td>-200.00</td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="juanis-student-ledger-payment-buttons">
          <button className="juanis-student-ledger-download-button" onClick={handleDownload}>
            <FontAwesomeIcon icon={faDownload} /> Download as PDF
          </button>
          <button className="juanis-student-ledger-print-button" onClick={handlePrint}>
            <FontAwesomeIcon icon={faPrint} /> Print
          </button>
        </div>

        <div className="juanis-student-ledger-payment-section">
          <h3>Make a Payment</h3>
          <form onSubmit={handlePaymentSubmit}>
            <div className="juanis-student-ledger-payment-input-group">
              <label>Amount to Pay:</label>
              <input
                type="number"
                className="juanis-student-ledger-payment-input"
                value={paymentAmount}
                onChange={(e) => setPaymentAmount(e.target.value)}
                placeholder="Enter amount"
                min="0"
                step="0.01"
              />
            </div>
            <button type="submit" className="juanis-student-ledger-proceed-button">
              Proceed to Payment
            </button>
          </form>
        </div>

        <div className="juanis-student-ledger-feedback-section">
          <h3>Feedback & Concerns</h3>
          <textarea
            className="juanis-student-ledger-feedback-textarea"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="Enter your feedback or concerns here..."
          />
          <button className="juanis-student-ledger-add-comment-button" onClick={handleAddComment}>
            Add Comment
          </button>
        </div>
      </div>
    </div>
  );
}

export default JuanISStudentLedger;